'use client';

import { UserMenu as SystemUserMenu, UserMenuLink } from '@instamenu/ui-system-next';
import { useRouter } from 'next/navigation';

export const UserMenu = () => {
  const router = useRouter();

  return (
    <SystemUserMenu>
      <UserMenuLink onClick={() => router.push('/account')}>Account</UserMenuLink>
    </SystemUserMenu>
  );
};
